export default "__VITE_ASSET__BqX9BdSw__"